'use strict';

const ua = navigator.userAgent.toLowerCase();

// iPhone
const isiPhone = (ua.indexOf('iphone') > -1);
// iPad
const isiPad = (ua.indexOf('ipad') > -1);
// Android
const isAndroid = (ua.indexOf('android') > -1) && (ua.indexOf('mobile') > -1);
// Android Tablet
const isAndroidTablet = (ua.indexOf('android') > -1) && (ua.indexOf('mobile') == -1);

let isMobile = (isiPhone || isiPad || isAndroid || isAndroidTablet);

// for Video
const video = document.getElementById('topVideo');
if (video) {
  video.autoplay = true;
  video.loop = true;
  video.muted = true;
  video.currentTime = 0;
}

let timer = 0;

$(function() {

  // Top Video
  $(window).on('load resize', function(){
    if (timer > 0) {
      clearTimeout(timer);
    }

    timer = setTimeout(function () {
      if (video) {
        if (isMobile) {
          video.pause();
        } else {
          video.play();
        }
      }
    }, 200);


  });

  // tabs click
  $('.triggerTabHeader').on('click', function() {
    let targetId = $(this).data('target');

    $('.triggerTabHeader').removeClass('active');
    $(this).addClass('active');


    $('.content-item').removeClass('active');
    $(targetId).addClass('active');
  });

  // mobile-nav
  $('#spNavBtn').on('click', function() {

    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $('#mobileChildNav').removeClass('active');
    } else {
      $(this).addClass('active');
      $('#mobileChildNav').addClass('active');
    }

  });



  const isTopPageNav = (!$('#jpGNav').hasClass('nav-active'));
  const isTopPageNavMobile = (!$('#jpGNavMobile').hasClass('nav-active'));


  // Scroll
  $(window).on('scroll', function() {
    if (isTopPageNav) {
      if ($(window).scrollTop() > $(window).height() - 70) {
        $('#jpGNav').addClass('nav-active');
      } else {
        $('#jpGNav').removeClass('nav-active');
      }
    }

    if (isTopPageNavMobile) {
      if ($(window).scrollTop() > $(window).height() - 50) {
        $('#jpGNavMobile').addClass('nav-active');
      } else {
        $('#jpGNavMobile').removeClass('nav-active');
      }
    }
  });

});



// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var aboutPlayer;
var topPlayer;

// YouTube IFrame APIのjsが読み込まれ終わったときの処理
function onYouTubeIframeAPIReady() {
  // プレイヤー作成
  aboutPlayer = new YT.Player("aboutMovie", {
    videoId: "KEYeICZP2Js",
    playerVars : {
      rel: 0,
      showinfo: 0,
    },
    events: {
      "onReady": function(event){
        event.target.mute()
      }
    }
  });
}

// スクロールイベント
if (!isMobile && document.getElementById("aboutMovie")) {
  window.addEventListener("scroll", function() {
    // 画面内にプレイヤーがあるかを判定
    if (window.scrollY < aboutPlayer.getIframe().offsetTop &&
    window.scrollY + window.screen.height > aboutPlayer.getIframe().offsetTop + aboutPlayer.getIframe().offsetHeight) {
      // 動画再生
      aboutPlayer.playVideo()
    } else {
      // 動画停止
      aboutPlayer.pauseVideo()
    }
  })
}
